/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import InlineSVG from 'svg-inline-react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import { Link } from 'react-router';
import _ from 'lodash';

import FileIcon from '../../../components/FileIcon/FileIcon';

import urlFromType from '../../../helpers/urlFromType';
import { humanizeFilesize } from '../../../models/File';
import { renderDateInGriddleCell } from '../../../helpers/renderDateInGriddleCell';
import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';

import DownloadIcon from '../../../assets/ic-file-download.svg';

import classes from './File.scss';

const renderExtension = data => <FileIcon extension={data.value} />;

const renderCell = data => {
  const values = _.split(data.value, ':-:');
  const name = values[0];
  // const id = values[1];
  const link = values[2];
  const fileSize = humanizeFilesize(parseInt(values[3], 10));

  return (
    <span>
      <Link to={link} target="_blank" className={classes.link}>
        {name}
      </Link>
      <span className={classes.fileSize}>{fileSize}</span>
    </span>
  );
};

const renderLinked = data => (
  <Link to={data.value._root.entries[1][1]}>
    {data.value._root.entries[0][1]}
  </Link>
);

const renderDateCell = data =>
  renderDateInGriddleCell(data, 'DD.MM.YYYY [ · ] HH:mm');
const prepareData = (dataArray, fetching) => {
  const newData = [];
  _.forOwn(dataArray, value => {
    if (value.deleted_at === null || typeof value.deleted_at !== 'undefined') {
      if (value.attachable_id !== null && value.attachable_type.length) {
        const filename = `${value.filename_download}:-:${value.id}:-:${value.download}:-:${value.filesize}`;
        const options = `${value.id}:-:${value.download}`;
        newData.push({
          id: value.id,
          extension: value.extension,
          filename,
          createdDate: value.created_at,
          linked: {
            title: `${value.attachable_name} (${value.attachable_type_name})`,
            link: urlFromType(value.attachable_type, value.attachable_id),
          },
          options,
        });
      }
    }
  });
  return newData;
};
class File extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }
  componentDidMount() {
    this.props.fetchFile();
  }
  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };
  renderOptionsCell = data => {
    const values = _.split(data.value, ':-:');
    const id = values[0];
    const link = values[1];
    return (
      <span>
        <Link to={link} target="_blank" className={classes.iconDownload}>
          <InlineSVG src={DownloadIcon} />
        </Link>
        <IconMenu
          iconButtonElement={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          }
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <MenuItem
            primaryText="Löschen"
            leftIcon={
              <DeleteIcon className="svg-icon-primary svg-icon-warning" />
            }
            onTouchTap={() => {
              this.setState({
                alert: (
                  <Dialog
                    actions={[
                      <FlatButton
                        label="Abbrechen"
                        primary
                        onTouchTap={this.handleAlertClose}
                      />,
                      <FlatButton
                        label="Löschen"
                        primary
                        onTouchTap={() => {
                          this.handleAlertClose();
                          this.props.deleteFile(id);
                        }}
                      />,
                    ]}
                    modal={false}
                    open
                    onRequestClose={this.handleAlertClose}
                  >
                    Datei wirklich löschen?
                  </Dialog>
                ),
              });
            }}
          />
        </IconMenu>
      </span>
    );
  };

  renderLinksMobile = dataArray => {
    const links = [];

    _.forOwn(dataArray, value => {
      links.push(
        <div key={`mobile_link_${value.id}`}>
          <Link to={`/file/${value.id}`}>{value.name}</Link>
        </div>,
      );
    });

    return links;
  };

  render() {
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Dateien hochgeladen.</small>
          </p>
        </div>
      ),
    };

    if (window.innerWidth < 767) {
      return (
        <div className="wrapper">
          <div>
            <h2 className={`${classes.zenHeader} gutter`}>Dateien</h2>

            <div className="mobile-list">
              {this.renderLinksMobile(this.props.files)}
            </div>
          </div>
        </div>
      );
    }

    const data = prepareData(this.props.files, this.props.fetching);
    const usedFormatted = numeral(this.props.limits.quotaUsed).format('0.0b');
    const quotaFormatted = numeral(this.props.limits.quota).format('0.0b');
    return (
      <div className="wrapper">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {data.length} Dateien - {usedFormatted} von {quotaFormatted}{' '}
            verwendet
          </h2>

          <Griddle
            data={data}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            sortMethod={caseInsensitiveSort}
            components={components}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="extension"
                title=" "
                sortable={false}
                customComponent={renderExtension}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="filename"
                title="Name"
                customComponent={renderCell}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="linked"
                title="Betrifft"
                customComponent={renderLinked}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="createdDate"
                title="Hochgeladen am"
                customComponent={renderDateCell}
              />
              <ColumnDefinition
                id="options"
                title=" "
                sortable={false}
                cssClassName={classes.options}
                customComponent={this.renderOptionsCell}
              />
            </RowDefinition>
          </Griddle>
        </div>
        {this.state.alert}
      </div>
    );
  }
}
File.propTypes = {
  fetchFile: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  deleteFile: PropTypes.func.isRequired,
  file: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  files: PropTypes.object.isRequired,
  limits: PropTypes.object.isRequired,
};
File.defaultProps = {
  fetching: false,
  file: {},
  files: {},
};
export default File;



// WEBPACK FOOTER //
// ./src/routes/File/components/File.js